<script>
	import { UserInfo } from '$lib/store.js';
	let uses = [
		{
			name: 'understand',
			text: 'Understanding exactly what companies know about me',
			selected: false
		},
		{ name: 'control', text: 'Deleting data from companies', selected: false },
		{ name: 'use', text: 'Using my data to enhance my life', selected: false }
	];
	$: $UserInfo.valueProps = uses?.filter((s) => s.selected).map((s) => s.name);
</script>

<h1 class="text-lg text-center">What do you want to use Magicflow for?</h1>
<div class="grid max-w-xl w-full gap-6 p-6">
	{#each uses as use}
		<card
			class="flex flex-col items-center gap-4 font-semibold cursor-pointer"
			on:click={() => (use.selected = !use.selected)}
			style={use.selected ? 'background:#00a4ff36' : 'background:black'}
		>
			<span>{use.text}</span>
			<!-- <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 ml-auto"
          viewBox="0 0 20 20"
          fill="currentColor">
          <path
            fill-rule="evenodd"
            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
            clip-rule="evenodd" />
        </svg> -->
		</card>
	{/each}
</div>
<a
	href="/onboard/recommendation"
	class="block mx-auto"
	disabled={!($UserInfo.valueProps || []).length}
>
	<button
		class="flip block rounded-lg text-2xl font-semibold"
		disabled={!($UserInfo.valueProps || []).length}
	>
		Next
	</button>
</a>
